import { createMetricsFactory } from 'metrics-js';
export const Metrics = createMetricsFactory('crm-fe-perf', {
  library: 'crm-fe-perf'
});